/* eslint-disable no-undef */
/**
 * Remove token from the local storage
 */
export function removeToken(token) {
  return localStorage.removeItem(token);
}

/**
 * Store {key, value} pair into the local storage
 * @param {string} key
 * @param {string} value
 */
export function storeItemInLocalStorage(key, value) {
  localStorage.setItem(key, value);
}

/**
 * Reads the value of the {key, value} pair from local storage
 * @param {string} key
 * @returns {string} value
 */
export function getItemFromLocalStorage(key) {
  return localStorage.getItem(key);
}
